import { render, staticRenderFns } from "./BreakInfinityButton.vue?vue&type=template&id=344c8f38&scoped=true"
import script from "./BreakInfinityButton.vue?vue&type=script&lang=js"
export * from "./BreakInfinityButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "344c8f38",
  null
  
)

export default component.exports